import { isDefined } from 'app-shared/utils';

import { NAVIGATION_ITEMS } from '@/navigation/constants/NavigationItems';
import { SETTINGS_NAVIGATION_ITEM } from '@/navigation/constants/SettingsNavigationItem';
import { GoToPageHotkeyEffect } from '@/navigation/effect-components/GoToPageHotkeyEffect';

// One effect per page that declares a go-to shortcut, so adding a shortcut is
// a one-line change in the navigation constants.
export const NavigationHotkeyEffects = () => (
  <>
    {[...NAVIGATION_ITEMS, SETTINGS_NAVIGATION_ITEM].map(
      (navigationItem) =>
        isDefined(navigationItem.goToHotkey) && (
          <GoToPageHotkeyEffect
            key={navigationItem.id}
            hotkey={navigationItem.goToHotkey}
            path={navigationItem.path}
          />
        ),
    )}
  </>
);
